//seo 相关
const metas = {
    home: {
      title: '东方希望公益基金会',
      meta: [
        {
          name: 'keywords',
          content: '关键字1,关键字1,关键字1'
        },
        {
          name: 'description',
          content: '这是一段网页的描述1'
        }
      ]
    },
    about: {
      title: '东方希望公益基金会',
      meta: [
        {
          name: 'keywords',
          content: '关键字2,关键字2,关键字2'
        },
        {
          name: 'description',
          content: '这是一段网页的描述2'
        }
      ]
    },
    third: {
      title: '东方希望公益基金会',
      meta: [
        {
          name: 'keywords',
          content: '关键字3,关键字3,关键字3'
        },
        {
          name: 'description',
          content: '这是一段网页的描述3'
        }
      ]
    },
  }

const getMeta = function(_this){
    // 获取与metas匹配的路由（routes）里面name字段
    if(Object.keys(metas).includes(_this.$route.name)){
        return metas[_this.$route.name];
    }
}
export default getMeta;